import {memo, useMemo} from 'react'
import {getAuthLayoutData} from '../../util'
import ProjectLayout from './index'

function registerProjectLayoutWrap(PageComponent) {
    const ProjectLayoutWrap = memo((props) => {
        const authLayoutData = useMemo(() => getAuthLayoutData(props?.location?.pathname), [
            props?.location?.pathname,
        ])

        if (authLayoutData) {
            if (authLayoutData?.hzLayoutOption?.noUseProjectLayoutComponent) {
                return <PageComponent {...props}>{props.children}</PageComponent>
            }

            return (
                <ProjectLayout
                    authLayoutData={authLayoutData}
                    pageProps={props}
                    PageComponent={PageComponent}
                >
                    {props.children}
                </ProjectLayout>
            )
        }

        return <PageComponent {...props}>{props.children}</PageComponent>
    })
    return ProjectLayoutWrap
}

export default registerProjectLayoutWrap
